module.exports = __webpack_public_path__ + "static/media/education-object-0-1-1.28d68684.svg";